import { useState, useEffect } from 'react';
import { getAmPm, get12HourFormat } from 'src/utils/time';

const useFormatDate = (dateInput) => {
  const [formattedDate, setFormattedDate] = useState('');

  useEffect(() => {
    if (!dateInput) {
      setFormattedDate('No date');
      return;
    }

    const formatDate = (input) => {
      let date;

      // Handle Date object or string input
      if (input instanceof Date) {
        date = input;
      } else if (typeof input === 'string') {
        // Try parsing the string directly first
        date = new Date(input);

        // If invalid, try the previous format handling
        if (isNaN(date.getTime()) && input.includes(' ')) {
          const utcDate = input.replace(' ', 'T') + '.000Z';
          date = new Date(utcDate);
        }
      } else {
        return 'Unknown date';
      }

      // Check if the date is invalid
      if (isNaN(date.getTime())) {
        return 'Unknown date';
      }

      const now = new Date();
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      const tomorrow = new Date(today.getTime() + 86400000);
      const inputDay = new Date(date.getFullYear(), date.getMonth(), date.getDate());
      const weekDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
      const day = date.getDay();
      const hours12 = get12HourFormat(date);
      const amPm = getAmPm(date);
      const minutesFormatted = date.getMinutes().toString().padStart(2, '0');

      if (inputDay.getTime() === today.getTime()) {
        return `Today, ${hours12}:${minutesFormatted} ${amPm}`;
      } else if (inputDay.getTime() === tomorrow.getTime()) {
        return `Tomorrow, ${hours12}:${minutesFormatted} ${amPm}`;
      } else if (inputDay.getTime() < today.getTime()) {
        return `${date.toLocaleString('en-US', { month: 'short' })} ${date.getDate()}, ${date.getFullYear()}`;
      } else if (Math.abs(inputDay.getTime() - today.getTime()) < 7 * 86400000) {
        return `${weekDays[day]}, ${date.toLocaleString('en-US', { month: 'short' })} ${date.getDate()}, ${hours12}:${minutesFormatted} ${amPm}`;
      } else {
        return `${date.toLocaleString('en-US', { month: 'short' })} ${date.getDate()}, ${date.getFullYear()}`;
      }
    };

    setFormattedDate(formatDate(dateInput));
  }, [dateInput]);

  return formattedDate;
};

export default useFormatDate;
